// extracted by mini-css-extract-plugin
export default {"navs":"navs___X754f","layout":"layout___Ps7xZ","divider":"divider___RVUOM","clickAvailable":"clickAvailable___KgAij"};